import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import DeleteIcon from '@material-ui/icons/Delete';
import clsx from 'clsx';
import { ExternalLink } from '@/components/functional/Link/ExternalLink';
import { propBool, propFunc, propStr } from '@/helpers/custom-prop-types';
/**
 * セミナー入力フォームのファイル名
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SeminarOneFormFileName = (props) => {
    const { className, disabled, fileName, filePath, onClickDelete } = props;
    return (_jsxs("div", Object.assign({ className: clsx('professional_seminar_one_form_file_name', className) }, { children: [_jsx(ExternalLink, Object.assign({ className: 'name_text link-text', href: filePath, target: '_blank', type: 'button' }, { children: fileName })), !disabled && (_jsx("button", Object.assign({ className: 'delete_button', onClick: onClickDelete, type: 'button' }, { children: _jsx(DeleteIcon, { className: 'delete_svg' }) })))] })));
};
SeminarOneFormFileName.propTypes = {
    className: propStr(),
    disabled: propBool(),
    fileName: propStr().isRequired,
    filePath: propStr().isRequired,
    onClickDelete: propFunc().isRequired,
};
SeminarOneFormFileName.defaultProps = {
    className: '',
    disabled: false,
};
export default SeminarOneFormFileName;
